<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <loader :isLoading="isLoading"></loader>
    <view-component v-if="attributes" :attributes="attributes"></view-component>
    <v-expansion-panels>
      <v-expansion-panel>
      <v-expansion-panel-header>
        Location
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ specimenData.location?.freezer }}
            </v-list-item-title>
            <v-list-item-subtitle>Freezer No.</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ specimenData.location?.temperature }}
            </v-list-item-title>
            <v-list-item-subtitle>Temperature</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ specimenData.location?.shelfNumber }}
            </v-list-item-title>
            <v-list-item-subtitle>Shelf No.</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ specimenData.location?.rackNumber }}
            </v-list-item-title>
            <v-list-item-subtitle>Rack No.</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ specimenData.location?.slidingRackNumber }}
            </v-list-item-title>
            <v-list-item-subtitle>Sliding Rack No.</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ specimenData.location?.boxNumber }}
            </v-list-item-title>
            <v-list-item-subtitle>Box Number</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ specimenData.location?.boxLocation }}
            </v-list-item-title>
            <v-list-item-subtitle>Box Location</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<!-- eslint-disable no-underscore-dangle -->
<script>
import Loader from '../../../components/utilities/Loader.vue';
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import ViewComponent from '../../../components/ViewComponent.vue';

import services from '../../../services';

const { biobankRegistry, medicalRegistry } = services; // medicalRegistry
const {
  caseSpecimenService,
  freezerService,
} = biobankRegistry;
const { caseService, protocolNumberService, specimenSourceService } = medicalRegistry;

export default {
  name: 'SpecimenView',
  components: {
    Loader,
    LandingCreate,
    ViewComponent,
  },
  data: () => ({
    isLoading: false,
    attributes: null,
    specimenData: {},
    content: {
      pageTitle: 'Specimen View',
      enableBackButton: true,
    },
  }),
  async created() {
    this.isLoading = true;

    const { id } = this.$route.params;
    const specimen = await caseSpecimenService.getOne({ id });
    this.specimenData = specimen;

    const { location } = this.specimenData;

    // set the name of freezer and its temperature
    const freezerData = await this.getFreezerData(location.freezer);
    if (Object.keys(freezerData).length) {
      location.temperature = freezerData.temperature;
      location.freezer = freezerData.name;
    }

    const {
      caseNumber,
    } = specimen;

    if (caseNumber) {
      specimen.caseNumber = await caseService.getOne({ id: caseNumber._id });
      const { specimenSource: _id } = specimen.caseNumber;
      specimen.caseNumber.specimenSource = await specimenSourceService.getOne({ id: _id });
    }

    if (specimen.protocolNumber) {
      specimen.protocolNumber = await protocolNumberService
        .getOne({ id: specimen.protocolNumber._id });
    }
    this.attributes = this.prepareAttribute(specimen);
    this.isLoading = false;
  },
  methods: {
    prepareAttribute({
      code,
      caseNumber,
      specimenSource,
      // caseNumberSpecimenSource,
      sampleFrom,
      specimenState,
      specimenType,
      protocolNumber,
      _metadata,
    }) {
      return [
        {
          label: 'Code',
          value: code,
        },
        {
          label: 'Case Number',
          value: this.checkExistingValue(caseNumber, 'None', 'caseNumber'),
          reference: !!caseNumber?._id,
          URLName: 'case.view',
        },
        {
          label: 'Specimen Source',
          value: this.checkExistingValue(caseNumber?.specimenSource || specimenSource, 'Not Applicable'),
          reference: specimenSource?._id || caseNumber?._id,
          URLName: 'specimen-source.view',
        },
        {
          label: 'Method of Collection',
          value: { id: sampleFrom._id, name: sampleFrom.name },
          reference: true,
          URLName: 'method-of-collection.view',
        },
        {
          label: 'Preparation',
          value: { id: specimenState._id, name: specimenState.name },
          reference: true,
          URLName: 'specimen-state.view',
        },
        {
          label: 'Specimen Type',
          value: { id: specimenType._id, name: specimenType.name },
          reference: true,
          URLName: 'specimen-type.view',
        },
        {
          label: 'Protocol Number',
          value: { id: protocolNumber._id, name: protocolNumber.protocolNumber },
          reference: true,
          URLName: 'protocol-number.view',
        },
        {
          label: 'Created by',
          value: { id: _metadata.created.user._id, name: _metadata.created.user.fullName },
          reference: true,
          URLName: 'user.view',
        },
        {
          label: 'Created date',
          value: _metadata.created.date,
          type: 'datetime',
        },
        {
          label: 'Updated by',
          value: { id: _metadata.updated.user._id, name: _metadata.updated.user.fullName },
          reference: true,
          URLName: 'user.view',
        },
        {
          label: 'Updated date',
          value: _metadata.updated.date,
          type: 'datetime',
        },
      ];
    },
    checkExistingValue(object, defaultValue, otherName = '') {
      let value = defaultValue;
      // checking for existing value
      if (object?._id) {
        value = { id: object._id, name: otherName || object.name };
      }
      return value;
    },
    async getFreezerData(freezerId) {
      return freezerService.getOne({
        id: freezerId,
      });
    },
  },
};
</script>
